module.exports = __webpack_public_path__ + "static/BOTWelcomeHeader-4361e545c9d66b7c276993dec2e0534d.jpg";